var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:[_vm.screenHeightClass, _vm.backgroundClass],attrs:{"fluid":""}},[_c('app-container',{class:_vm.marginTop ? 'app-container-padding' : null,scopedSlots:_vm._u([{key:"appContainerContent",fn:function(){return [_vm._t("sectionContent")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }